<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row d-flex align-items-center justify-content-between align-items-center mb-3">
      <div>
           <label
            for="card-type"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            Show for users with these tags
          </label>
        <!-- <label class="form-label offcanvas-header-text">Show for users with these tags</label> -->
        <ng-select class="custom-select" [items]="page" bindLabel="name" bindValue="id" placeholder="Select Tags"
          [(ngModel)]="tag_values" [multiple]="true" (change)="updatePostTags()">
        </ng-select>
      </div>
    </div>
  </div>
</div>
